<template>
	<div>
		<Form ref="SelectParam" :model="SelectParam" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="价格名称:" :label-width="100">
				<Input type="text" v-model="SelectParam.Name" placeholder="价格名称" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSearch('SelectParam')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="showModal('modal_add')" v-if="hasWidgets('add')">添加价格</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
		</Form>
		<Table :columns="tableColumns" :data="tableData" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getOccupyPriceListUrl" @listData='getTableData'></MyPage>
		<Modal :mask-closable="false" v-model="modalView" title="新增价格" width="400">
			<Form label-position="right" :rules="ruleInline" ref="PriceForm" :model="PriceForm" :label-width="150">
				<FormItem label="价格名称" prop="Name">
					<Input v-model="PriceForm.Name" placeholder="输入价格名称"></Input>
				</FormItem>
				<FormItem label="冻结金额" prop="FreezeAmount">
					<Input v-model="PriceForm.FreezeAmount" placeholder="输入冻结金额"></Input>
				</FormItem>
				<FormItem label="免费时长(分钟)" prop="FreeDuration">
					<Input v-model="PriceForm.FreeDuration" placeholder="输入免费时长,单位:分钟"></Input>
				</FormItem>
				<FormItem label="计费价格(元/周期)" prop="PeriodPrice">
					<Input v-model="PriceForm.PeriodPrice" placeholder="输入计费价格"></Input>
				</FormItem>
				<FormItem label="计费周期(分钟)" prop="PeriodInterval">
					<Input v-model="PriceForm.PeriodInterval" placeholder="计费周期,单位:分钟"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk('add')">新增</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import webapi from '../../../webapi.js';
	export default {
		data() {
			return {
				getOccupyPriceListUrl: webapi.base_api_url + '/Archives/GetOccupyPriceTemplateList',
				//Query Component Parameters
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['档案管理', '>>', '价格管理'],
				modalView: false,
				//Table Title Data
				tableColumns: [ {
						title: '价格名称',
						key: 'Name',
						minWidth: 120,
					}, {
						title: '免费时长(分钟)',
						key: 'FreeDuration',
						minWidth: 100,
					}, {
						title: '冻结金额(元)',
						key: 'FreezeAmount',
						minWidth: 100,
					}, {
						title: '计费周期(分钟)',
						key: 'PeriodInterval',
						minWidth: 100,
					}, {
						title: '计费价格(元/周期)',
						key: 'PeriodPrice',
						minWidth: 100,
					}
				],
				tableData: [],
				ruleInline: {
					Name: [{
						required: true,
						message: '请输入价格名称',
						trigger: 'blur'
					}],
				},
				defaultPrice: {
					Name: '',
					FreezeAmount: 0,
					FreeDuration: 0,
					PeriodPrice: 0,
					PeriodInterval: 1
				},
				PriceForm: {}
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.$nextTick(() => {
				this.handleSearch();
			})
		},
		computed: {
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			/**Component Fixing Method**/
			showModal: function(type, params) {
				this.PriceForm = Object.assign({}, this.defaultPrice);
				this.modalView = true;
			},
			getTableData: function(data) {
				if (!this.hasWidgets('search')) return;
				console.log(data)
				this.tableData = data.Data.List
			},
			handleSearch: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				this.PriceForm = Object.assign({}, this.defaultPrice);
			},
			modalOk: function() {
				this.$axios.post(webapi.base_api_url + '/Archives/AddOccupyPriceTemplate', this.PriceForm).then(res => {
					if (res.data.Code == 0) {
						this.$Message.success(this.$t('Common.AddSuccess'));
						this.handleSearch();
					}
				})
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
